"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5226],{

/***/ 78259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/constants/meta.ts
/* harmony default export */ var meta = ({
    image: "https://www.priceline.com/static-pages/images/Artboard.png",
    url: "https://www.priceline.com",
    name: "vacationpackages",
    description: {
        vacationpackages: "Save up to 625 dollars when you book your flight and hotel together! " + "Priceline&trade; Vacation packages with exclusive deals on airline tickets " + "& hotels worldwide. How much will you save?",
        flights: "Looking to save on your next flight? We compare thousands of flight deals to get you there. Book a cheap flight today with free cancellation for more flexibility.",
        hotels: "Get great deals on hotels, resorts and private rentals. Save even more on last minute deals and hotels nearby. Book a hotel for cheap today with free cancellation for more flexibility.",
        vip: "Become a Priceline VIP member for free. Unlock huge savings, deals & travel perks. See what tier you qualify for today.",
        homepage: "Deep Discounts on Hotels, Flights and Rental Cars.  Get Exclusive Savings with Priceline.com."
    },
    title: {
        "/flights": "Flights: Find Cheap Flights & Airfares | Priceline",
        "/hotels": "Hotels: Find Cheap Hotel Rooms & Discount Hotels | Priceline",
        "/hotels/nha": "Hotels: Find Cheap Hotel Rooms & Discount Hotels | Priceline",
        "/vacationpackages": "Packages: Find bundle deals on a hotel, flight, & rental car vacation | Priceline",
        "/vip": "Priceline VIP - Unlock savings, deals & travel perks | Priceline",
        "/dsarwebform": "CCPA - Do Not Sell My Info Request | Priceline",
        "/app-delete-account": "Delete Account Request | Priceline",
        "/": "Priceline.com - The Best Deals on Hotels, Flights and Rental Cars."
    }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/Meta/Template.tsx






var renderLinks = function(linkTags) {
    return linkTags.map(function(linkTag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", (0,_object_spread/* default */.Z)({}, linkTag), linkTag.href);
    });
};
function Template(param) {
    var additionalLinks = param.additionalLinks, brandUrl = param.brandUrl, description = param.description, favicons = param.favicons, googleVerification = param.googleVerification, imageUrl = param.imageUrl, title = param.title, twitterHandle = param.twitterHandle;
    var router = (0,next_router.useRouter)();
    var _pathname = router.pathname, pathname = _pathname === void 0 ? "/vacationpackages" : _pathname;
    var baseUrl = (0,react.useContext)(BootstrapDataContext/* default */.Z).baseUrl;
    var pageUrl = "".concat(baseUrl).concat(pathname);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: brandUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:url",
                content: brandUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:site",
                content: twitterHandle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noydir,noodp"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "language",
                content: "english"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                className: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "google-site-verification",
                content: "NfW_2qut5D0YEqJE2_8tqKYUKrWju1NsVFUc4Kxl7Sw"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "google-site-verification",
                content: "F8oXNWFYF1zWWLC_bBMEiUaKq588GpL8o0r0r30sQtk"
            }),
            googleVerification && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "google-site-verification",
                content: googleVerification
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0, maximum-scale=6.0, user-scalable=yes height=device-height"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "Pragma",
                content: "no-cache"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "Expires",
                content: "-1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "Expires",
                content: "Tue, 01 Jan 1980 1:00:00 GMT"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "Cache-Control",
                content: "no-store, no-cache, must-revalidate, post-check=0, pre-check=0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "Cache-Control",
                content: "max-age=0"
            }),
            favicons && renderLinks(favicons),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: pageUrl
            }),
            additionalLinks && renderLinks(additionalLinks),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            })
        ]
    });
}
/* harmony default export */ var Meta_Template = (Template);

;// CONCATENATED MODULE: ./src/components/Meta/Meta.tsx






function Meta() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useContext)(BootstrapDataContext/* default */.Z), insideTrackTitle = ref3.insideTrackTitle, referral = ref3.referral, prePopData = ref3.prePopData;
    var router = (0,next_router.useRouter)();
    var _pathname = router.pathname, pathname = _pathname === void 0 ? "/vacationpackages" : _pathname;
    var image = meta.image, url = meta.url, description = meta.description, title = meta.title;
    var cityName = prePopData === null || prePopData === void 0 ? void 0 : (ref = prePopData.hotels) === null || ref === void 0 ? void 0 : (ref1 = ref.endLocation) === null || ref1 === void 0 ? void 0 : ref1.cityName;
    var isSEMCampaign = (referral === null || referral === void 0 ? void 0 : (ref2 = referral.clickId) === null || ref2 === void 0 ? void 0 : ref2.includes("hotel")) && cityName;
    var pricelineTitle = isSEMCampaign ? "The Best Deals on ".concat(cityName, " Hotels at Priceline.com") : title[pathname];
    var isHotelsLP = [
        "/hotels",
        "/hotels/"
    ].includes(pathname);
    var isFlightLP = [
        "/flights",
        "/flights/"
    ].includes(pathname);
    var isVIPLP = [
        "/vip",
        "/vip/"
    ].includes(pathname);
    var isHomepageLP = [
        "/"
    ].includes(pathname);
    var metaDescription = description.vacationpackages;
    if (isFlightLP) {
        metaDescription = description.flights;
    } else if (isHotelsLP) {
        metaDescription = description.hotels;
    } else if (isVIPLP) {
        metaDescription = description.vip;
    } else if (isHomepageLP) {
        metaDescription = description.homepage;
    }
    var favicons = [
        {
            rel: "shortcut icon",
            href: "/favicon.ico",
            type: "image/x-icon"
        }
    ];
    var additionalLinks = [
        {
            rel: "alternate",
            href: "android-app://com.priceline.android.negotiator/pclnnegotiator/home"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta_Template, {
        additionalLinks: additionalLinks,
        brandUrl: url,
        description: metaDescription,
        favicons: favicons,
        imageUrl: image,
        title: insideTrackTitle || pricelineTitle,
        twitterHandle: "@priceline"
    });
}
/* harmony default export */ var Meta_Meta = (Meta);

;// CONCATENATED MODULE: ./src/components/Meta/index.tsx


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(37138);
;// CONCATENATED MODULE: ./src/utils/create-markup.ts
var createMarkup = function(__html) {
    return {
        __html: __html
    };
};
/* harmony default export */ var create_markup = (createMarkup);

;// CONCATENATED MODULE: ./src/components/Footer/Footer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledFooter = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
    componentId: "sc-83b3ffc4-0"
})(_templateObject(), (0,index_esm/* themeGet */.R)("mediaQueries.md"));
function Footer(param) {
    var footerHTML = param.footerHTML;
    return footerHTML.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
        id: "expr-ftr",
        className: "experimental-footer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: create_markup(footerHTML),
            id: "pcln-global-footer",
            style: {
                visibility: "hidden"
            }
        })
    }) : null;
}
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./src/components/Footer/index.tsx


// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Divider/Divider.js
var Divider = __webpack_require__(11477);
;// CONCATENATED MODULE: ./src/components/Cobrand/constants.ts
var imageFolder = "https://s1.pclncdn.com/design-assets/next-landing/assets/images/cobrand/";
var affirm = {
    alt: "Welcome Affirm member, thanks for choosing priceline",
    src: "".concat(imageFolder, "cobrand-affirm-promo.jpg?opto&auto=avif,webp")
};
var klarna = {
    alt: "Welcome Klarna member, thanks for choosing priceline",
    src: "".concat(imageFolder, "cobrand-klarna-promo.jpg?opto&auto=avif,webp")
};
var cobrands = {
    co46157: {
        alt: "Welcome Rakuten member, thanks for choosing priceline",
        src: "".concat(imageFolder, "cobrand-rakuten-promo.jpg?opto&auto=avif,webp")
    },
    co2210202: {
        alt: "Welcome RetailMeNot shopper, save on all your travel needs!",
        src: "".concat(imageFolder, "cobrand-retailmenot-promo.jpg?opto&auto=avif,webp")
    },
    plchpcruises: {
        alt: "CheapCruises.com Priceline Express Deal",
        src: "".concat(imageFolder, "cobrand-cheap-cruises-promo.jpg?opto&auto=avif,webp")
    },
    plc411: {
        alt: "Cruise411 Priceline Express Deals",
        src: "".concat(imageFolder, "cobrand-cruise411-promo.jpg?opto&auto=avif,webp")
    },
    plcruises: {
        alt: "Cruises Priceline Express Deals",
        src: "".concat(imageFolder, "cobrand-cruises-com-promo.jpg?opto&auto=avif,webp")
    },
    plconly: {
        alt: "CruisesOnly Priceline Express Deal",
        src: "".concat(imageFolder, "cobrand-cruises-only-promo.jpg?opto&auto=avif,webp")
    },
    pllux: {
        alt: "Luxury Only Priceline Express Deal",
        src: "".concat(imageFolder, "cobrand-luxury-only-promo.jpg?opto&auto=avif,webp")
    },
    co5464610: {
        alt: "Welcome TopCashback Member, earn cash back on your travel order",
        src: "".concat(imageFolder, "cobrand-topcashback-promo.jpg?opto&auto=avif,webp")
    },
    co8191141: affirm,
    co100011847: affirm,
    co100187965: affirm,
    co9252602: klarna,
    co100136872: klarna,
    co100688040: klarna
};
function getCobrandContent(refid) {
    var ref;
    return cobrands[(ref = refid === null || refid === void 0 ? void 0 : refid.toLowerCase()) !== null && ref !== void 0 ? ref : ""];
}

;// CONCATENATED MODULE: ./src/components/Cobrand/index.tsx

function Cobrand_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  padding-bottom: 8px;\n  padding-top: 8px;\n"
    ]);
    Cobrand_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-d8b0412c-0"
})(Cobrand_templateObject());
// Displays when users are navigated to Priceline through referral partners
function Cobrand() {
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), tmp = ref.referral, ref1 = tmp === void 0 ? {} : tmp, _id = ref1.id, id = _id === void 0 ? "" : _id, _sourceId = ref1.sourceId, sourceId = _sourceId === void 0 ? "" : _sourceId;
    var query = (0,next_router.useRouter)().query;
    var refid = sourceId + id;
    var promo = getCobrandContent(refid);
    return promo && (query === null || query === void 0 ? void 0 : query.refid) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        color: "background.lightest",
        width: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                borderColor: "border.base",
                my: 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                alt: promo.alt,
                src: promo.src
            })
        ]
    }) : null;
}

;// CONCATENATED MODULE: ./src/components/Header/Header.tsx




function Header(param) {
    var headerHTML = param.headerHTML;
    return headerHTML.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "exp-hdr",
        className: "experimental-header",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: create_markup(headerHTML),
                className: "fixed",
                id: "pcln-global-header"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cobrand, {})
        ]
    }) : null;
}
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./src/components/Header/index.tsx


;// CONCATENATED MODULE: ./src/components/Layout/index.tsx





function Layout(param) {
    var headerHTML = param.headerHTML, footerHTML = param.footerHTML, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta_Meta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                headerHTML: headerHTML
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {
                footerHTML: footerHTML
            })
        ]
    });
}
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 38704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TmsScript; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/constants/path-map.ts
var pathMap = {
    "/": "home",
    "/home": "home",
    "/home/": "home",
    "/hotels": "hotels",
    "/hotels/": "hotels",
    "/vacationpackages": "packages",
    "/vacationpackages/": "packages",
    "/flights": "flights",
    "/flights/": "flights",
    "/insideTrack/flights": "flights"
};
function normalizePath(path) {
    if (path.startsWith("/insideTrack/flights")) {
        return "/insideTrack/flights";
    }
    return path;
}
function isValidPath(path) {
    return pathMap[normalizePath(path)] !== undefined;
}
/**
 *
 * inside track paths are actually formed like /insideTrack/flights/from_New_York_City-NYC.html
 * so this param is cheating a little
 */ function mapPath(path) {
    return pathMap[normalizePath(path)];
}

// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/components/TmsScript/useTmsConfig.ts





var ProductIds = {
    hotels: 5,
    flights: 1,
    packages: 17,
    home: 16
};
function useTmsConfig(pathname) {
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), isMobile = ref.isMobile, referral = ref.referral, seti = ref.seti, webstats = ref.webstats, sha2e = ref.sha2e, _vipTier = ref.vipTier, vipTier = _vipTier === void 0 ? "" : _vipTier;
    if (!isValidPath(pathname)) {
        return null;
    }
    var _clickId = referral.clickId, clickId = _clickId === void 0 ? "" : _clickId, _id = referral.id, id = _id === void 0 ? "" : _id, _sourceId = referral.sourceId, sourceId = _sourceId === void 0 ? "" : _sourceId;
    var firstTimeHere = webstats.firstTimeHere, startOfVisit = webstats.startOfVisit;
    var tmsData = {
        appCode: isMobile ? "MOBILEWEB" : "DESKTOP",
        sha2e: sha2e,
        refId: sourceId + id,
        refClickId: clickId,
        SETI: seti,
        firstTimeHere: firstTimeHere,
        startOfVisit: startOfVisit,
        vipTier: vipTier || "NONE",
        vipMember: vipTier ? "Yes" : "No"
    };
    var product = mapPath(pathname);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tmsData), {
        pageType: product === "home" ? "hp" : "prodhp",
        productId: ProductIds[product]
    });
}

;// CONCATENATED MODULE: ./src/components/TmsScript/TmsScript.tsx




function TmsScript(param) {
    var pathname = param.pathname;
    var tmsConfig = useTmsConfig(pathname);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "pclntms-script",
        strategy: "afterInteractive",
        src: "/svcs/mkt/tag/pclntms.js",
        onLoad: function() {
            if (window.pclntms) {
                window.pclntms.push(tmsConfig);
            }
        }
    });
}


/***/ }),

/***/ 8176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useGA4AnalyticsForSETI; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@pcln/analytics/dist/esm/browser.js + 21 modules
var browser = __webpack_require__(41525);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/constants/page-map.ts
var pageMap = {
    "/": "homepage",
    "/hotels": "landingpage",
    "/flights": "landingpage",
    "/vacationpackages": "landingpage",
    "/vip": "vip"
};
function mapPage(page) {
    return pageMap[page];
}

;// CONCATENATED MODULE: ./src/constants/product-map.ts
var productMap = {
    "/": "",
    "/hotels": "hotel",
    "/flights": "air",
    "/vacationpackages": "bundle",
    "/vip": "",
    vacations: "bundle",
    hotels: "hotel",
    flights: "air",
    cars: "car",
    cruises: "cruise"
};
function mapProduct(product) {
    return productMap[product];
}

;// CONCATENATED MODULE: ./src/hooks/useRouteInfo.ts



function useRouteInfo() {
    var ref = (0,router.useRouter)(), pathname = ref.pathname, query = ref.query;
    var pageName = mapPage(pathname);
    var currentTab = (query === null || query === void 0 ? void 0 : query.tab) && !Array.isArray(query.tab) ? query.tab : undefined;
    var productName = currentTab ? mapProduct(currentTab) : mapProduct(pathname);
    return {
        pageName: pageName,
        productName: productName
    };
}

;// CONCATENATED MODULE: ./src/hooks/useGA4Analytics.ts




function isSuccessfulSetiResponse(fullSeti) {
    return fullSeti.length === 0 || fullSeti[0].setiID !== undefined && fullSeti[0].setiVariantID !== undefined;
}
function useGA4AnalyticsForSETI(experimentCode) {
    var fullSETI = (0,react.useContext)(BootstrapDataContext/* default */.Z).fullSETI;
    var routeInfo = useRouteInfo();
    var logGA4Event = (0,react.useCallback)(function() {
        var baseSETI;
        if (isSuccessfulSetiResponse(fullSETI)) baseSETI = fullSETI.find(function(seti) {
            return seti.setiTagName === experimentCode;
        });
        if (!(baseSETI === null || baseSETI === void 0 ? void 0 : baseSETI.setiID)) return;
        browser/* default.GA4Enabled */.Z.GA4Enabled = true;
        browser/* default.logEvent */.Z.logEvent({
            event: "seti",
            attributes: {
                seti_id: baseSETI.setiID,
                seti_variant_id: baseSETI.setiVariantID,
                seti_name: experimentCode,
                page_name: routeInfo.pageName,
                product_name: routeInfo.productName
            }
        });
        browser/* default.GA4Enabled */.Z.GA4Enabled = false;
    }, [
        experimentCode,
        fullSETI,
        routeInfo
    ]);
    return {
        logGA4Event: logGA4Event
    };
}


/***/ }),

/***/ 39939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSeti; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pcln_experimentation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80460);
/* harmony import */ var _context_ExperimentContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68374);
/* harmony import */ var _useGA4Analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8176);




function useSeti(experimentCode) {
    var shouldFireImpression = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_ExperimentContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), tmp = ref[experimentCode], setiTest = tmp === void 0 ? "DEFAULT" : tmp;
    var logGA4Event = (0,_useGA4Analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(experimentCode).logGA4Event;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (experimentCode && shouldFireImpression) {
            _pcln_experimentation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireImpression */ .Z.fireImpression(experimentCode);
            logGA4Event();
        }
    }, [
        experimentCode,
        logGA4Event,
        shouldFireImpression
    ]);
    return setiTest;
}


/***/ })

}]);